// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2d2fb8b5","239":"5af8e7cd","455":"7658d26e"}[chunkId] + ".chunk.js";
};